import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from '../store/actions';

import { Icon, Tooltip } from '@material-ui/core';
import { Card, CardHeader, Button, CardContent, Divider, List } from '@material-ui/core';
import FlipMove from 'react-flip-move';
import ChoiceAnswer from './questionType/ChoiceAnswer';
import TextAnswer from './questionType/TextAnswer';
import OrderAnswer from './questionType/OrderAnswer';
import HotSpotAnswer from './questionType/HotSpotAnswer';

const styles = theme => ({
    layoutRoot: {},
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    button: {
        margin: theme.spacing.unit,
    },
    expansion: {}
});

class AnswerListEdit extends Component {

    handleChange = (field_name) => (event) => {
        const { answer, question_id, updateAnswer } = this.props;

        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        const update_data = {
            [field_name]: value
        }

        updateAnswer(question_id, answer.header.answer_id, update_data);
    }

    handleAddAnswer = (question) => {
        const { addAnswer } = this.props;
        
        addAnswer(question.header.question_id)
    }

    getAnswerContent = (question) => {
        const { view_type } = this.props;
        const question_type_id = question.header.question_type_id;
        
        switch(question_type_id)
        {
            case(1): // Multiple Choice
            case(4): // Multiple Answer
            {
                return (
                    <List>
                        <FlipMove>
                            {question.answerList.map((answer) =>
                                <div key={answer.header.answer_id}>
                                    <Divider light />
                                    <ChoiceAnswer
                                        answer={answer}
                                        question={question}
                                        view_type={view_type}
                                    />
                                </div>
                            )}
                        </FlipMove>
                    </List>
                );
            }
            
            case(2): // Short Answer
            case(3): // Long Answer
            {
                return (
                    <TextAnswer
                        question={question}
                        view_type={view_type}
                    />
                );
            }

            case(5): // Order Answer
            {
                return (
                    <OrderAnswer
                        question={question}
                        view_type={view_type}
                    />
                );
            }

            case(6): // Hot Spot Question
            {
                return (
                    <HotSpotAnswer
                        question={question}
                        view_type={view_type}
                    />
                )
            }

            default: {}
        }
    }

    render() {
        const { question, classes, addAnswer, view_type } = this.props;

        const answerContent = this.getAnswerContent(question);

        return (
            <Card className={classes.card}>
                <CardHeader
                    title={question.header.question_type_id !== 6 ? 'Answer List' : ''}
                    action={
                        // Only show add button if MultipleChoice OR MultipleAnswer
                        (question.header.question_type_id === 1 || question.header.question_type_id === 4 || question.header.question_type_id === 5) ?
                            <Tooltip title="Add new Answer">
                                <Button
                                    variant="fab"
                                    color="secondary"
                                    aria-label="Add new Answer"
                                    className={classes.button}
                                    onClick={() => this.handleAddAnswer(question)}
                                    mini
                                    disabled={view_type === 'detail'}
                                    hidden={view_type === 'detail'}
                                >
                                    <Icon>add</Icon>
                                </Button>
                            </Tooltip>
                        : <div></div>
                    }
                />
                <CardContent>
                    {answerContent}
                </CardContent>
            </Card>
        );
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        addAnswer:    Actions.addAnswer,
    }, dispatch);
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(null, mapDispatchToProps)(AnswerListEdit)));


// WEBPACK FOOTER //
// src/main/content/quiz/quizBuilder/QuestionAnswers.js